(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lauremonte-voyage-product"]) return;
  try {
    
  document.addEventListener('click', async function(event) {
    const button = event.target.closest('[data-voyage-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    const root = button.closest('.lm-voyage');
    const status = root.querySelector('[data-voyage-status]');
    button.disabled = true;
    status.textContent = 'Lägger till…';
    try {
      const response = await fetch(root.dataset.voyageAddUrl, { method:'POST', headers:{Accept:'application/json'}, body:new FormData(button.form) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Produkten kunde inte läggas till. Försök igen.');
      window.location.assign(root.dataset.voyageCartUrl);
    } catch (error) {
      status.textContent = error.message;
      button.disabled = false;
    }
  }, true);
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-voyage-select], [data-voyage-step]');
    if (!button) return;
    const root = button.closest('.lm-voyage');
    if (!root) return;
    const images = Array.from(root.querySelectorAll('[data-voyage-image]'));
    const current = images.findIndex(image => !image.hidden);
    const index = button.hasAttribute('data-voyage-select') ? Number(button.dataset.voyageSelect) : (current + Number(button.dataset.voyageStep) + images.length) % images.length;
    images.forEach((image, i) => { image.hidden = i !== index; });
    root.querySelectorAll('[data-voyage-select]').forEach((item, i) => item.setAttribute('aria-pressed', String(i === index)));
    root.querySelector('[data-voyage-gallery-status]').textContent = 'Bild ' + (index + 1) + ' av ' + images.length;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
